import { useTranslation } from 'react-i18next'

import { AIButtonContainedDark } from '../../../AIButton'
import Text from '../../../Text'
import { QA_NAME_GRETA_AI_CHAT_NEW_PROJECT } from '../../GretaAIChat.constants'

import * as styles from './GretaAIChatProjectsPageHeader.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function GretaAIChatProjectsPageHeader({ count, isCountShown = false }) {
  const { t } = useTranslation()

  return (
    <div className={styles.header}>
      <div className={styles.heading}>
        <Text Element='h1' className={styles.title}>
          {t('Greta.ProjectsSectionKey')}
        </Text>
        {isCountShown ? (
          <Text isSecondary Element='p' className={styles.count}>
            {t('Greta.ProjectsCountKey', { count })}
          </Text>
        ) : null}
      </div>
      <AIButtonContainedDark
        beforeIconProps={{ Icon: PlusIcon }}
        qaName={QA_NAME_GRETA_AI_CHAT_NEW_PROJECT}
        text={t('Greta.NewProjectKey')}
      />
    </div>
  )
}

export default GretaAIChatProjectsPageHeader
